import React, { FC, ReactNode } from 'react';

interface BookingConfirmationPart {
  heading: string;
  body?: string | ReactNode;
}

export const BookingConfirmationPart: FC<BookingConfirmationPart> = (props) => {
  const { heading, body } = props;
  return (
    <div className="bookingConfirmationPart">
      <h4 className="bookingConfirmationPart__heading">
        {heading}
      </h4>
      <div className="bookingConfirmationPart__body">
        {body ? body : "-"}
      </div>
    </div>
  )
};
